<div *ngIf="control?.errors" class="invalid-feedback" [ngClass]="{ 'd-inline-block': control?.dirty && control.touched && control?.errors }">

  <ng-container *ngFor="let error of control.errors | keyvalue">{{ getError(error.key) }}</ng-container>

</div>
